<template>
    <div>
        <b-row class="ml-1">
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>N°/Ano da Licitação</b></span>
                <br />
                <span class="pos-left">{{ ctrRegPreco.NrLicitacao+"/"+ctrRegPreco.NrAnoLicitacao }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Modalidade da Licitação</b></span>
                <br />
                <span class="pos-left">{{ ctrRegPreco.IdModalidadeNavigation.DeModalidade }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Unidade Federativa</b></span>
                <br />
                <span class="pos-left">{{ ctrRegPreco.SgUf }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Município</b></span>
                <br />
                <span class="pos-left">{{ ctrRegPreco.NmMunicipio }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Órgão Responsável</b></span>
                <br />
                <span class="pos-left">{{ ctrRegPreco.NmOrgaoResp }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>CNPJ Órgão Responsável</b></span>
                <br />
                <span class="pos-left">{{ ctrRegPreco.NrCnpjOrgaoResp }}</span>
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

import { ContratoRegistroPreco } from '@/types/licitacoes/contratos/contrato-registro-preco'

const CompProps = Vue.extend({
    name: 'DetalhesContratoLicitacaoOutraUG',
    props: {
        ctrRegPreco: {
            type: ContratoRegistroPreco,
            required: true
        }
    }
})

@Component
export default class DetalhesContratoCentralizado extends mixins(UtilsTS, CompProps) {}
</script>

<style></style>